var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"serve-sell"},[_c('div',{staticClass:"content"},[_c('course-list',{attrs:{"list":_vm.list,"up-id":_vm.upId,"header":_vm.headerTop,"page":_vm.page,"option-id":_vm.optionId,"page-name":_vm.pageName,"all-data":_vm.allData},on:{"up-list":_vm.upList}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }